import React from 'react';
import { useHelp } from '.';
import Doc from '../../Pages/Help/Doc';

const Help = () => {
    const {openDoc, setOpenDoc} = useHelp();

    return openDoc ? <Doc docId={openDoc} isOpen={!!openDoc} onClose={() => setOpenDoc(null)} /> : null;
}

export default Help;